// 质量评分折线图
const qualityScoreLineOption = {
  color: [
    '#23A7FE',
    '#FF9502',
    '#18DBDB',
    '#9E63F0',
    '#8396D3',
    '#F3DB00',
    '#2BC17A',
    '#0082F7',
    '#AED79A',
    '#EF8F8F',
  ],
  tooltip: {
    trigger: 'axis',
  },
  grid: {
    left: 40,
    bottom: 20,
    right: 0,
    top: 30,
  },
  legend: {
    show: false, // 不显示图例
    top: 0,
    right: '0',
    data: ['评分', '评分2'],
    icon: 'circle',
    itemWidth: 8,
    itemHeight: 8,
    textStyle: {
      color: 'rgba(0, 0, 0, 0.8)',
      fontSize: 12,
    },
  },
  xAxis: {
    type: 'category',
    data: ['20240824', '20240825', '20240826', '20240827', '20240828', '20240829', '20240830'],
    nameLocation: 'start',
    axisLabel: {
      color: 'rgba(0, 0, 0, 0.6)',
      interval: 0,
    },
    axisLine: {
      show: true,
      lineStyle: {
        color: 'rgba(0, 0, 0, 0.1)',
        width: 1,
      },
    },
    axisTick: {
      show: false,
      lineStyle: {
        color: 'rgba(0, 0, 0, 0.3)',
        width: 1,
      },
    },
  },
  yAxis: {
    type: 'value',
    nameTextStyle: {
      color: 'rgba(0, 0, 0, 0.1)',
      fontSize: 12,
      padding: [0, 30, 0, 0],
    },
    nameLocation: 'start',
    // splitNumber: 4,
    axisLine: {
      show: false,
      lineStyle: {
        color: 'rgba(0, 0, 0, 0.8)',
        width: 1,
      },
    },
    splitLine: {
      show: true,
      lineStyle: {
        color: 'rgba(0, 0, 0, 0.1)',
        width: 1,
      },
    },
    axisTick: false,
  },
  series: [
    {
      name: '评分',
      data: [0, 0, 0, 0, 0, 0, 0],
      type: 'line',
      smooth: false,
      // symbol: 'circle',
      symbolSize: 8,
      itemStyle: {
        normal: {
          color: '#23A7FE',
          lineStyle: {
            color: '#45a4f9',
            width: 1,
          },
          areaStyle: {
            color: '#cbeaff',
          },
        },
      },
    },
    // {
    //   name: '评分2',
    //   data: [25, 60, 45, 80, 20, 30, 78],
    //   type: 'line',
    //   smooth: false,
    //   // symbol: 'circle',
    //   symbolSize: 8,
    //   itemStyle: {
    //     normal: {
    //       color: '#23A7FE',
    //       lineStyle: {
    //         color: '#45a4f9',
    //         width: 1,
    //       },
    //       areaStyle: {
    //         color: '#cbeaff',
    //       },
    //     },
    //   },
    // },
  ],
}
// 质量评分仪表盘
const qualityScoreDashboardOption = {
  series: [
    {
      name: '评分',
      type: 'gauge',
      radius: '50%',
      // center: ["50%", "30%"],
      itemStyle: {
        // 渐变颜色
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0.1,
              color: '#bbeac0',
            },
            {
              offset: 0.3,
              color: '#93e29d',
            },
            {
              offset: 0.6,
              color: '#4fd25f',
            },
            {
              offset: 1,
              color: '#26c93a',
            },
          ],
        },
        // color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
        //   {
        //     offset: 0.1,
        //     color: '#bbeac0',
        //   },
        //   {
        //     offset: 0.3,
        //     color: '#93e29d',
        //   },
        //   {
        //     offset: 0.6,
        //     color: '#4fd25f',
        //   },
        //   {
        //     offset: 1,
        //     color: '#26c93a',
        //   },
        // ]),
      },
      progress: {
        show: true,
        width: 55,
      },
      axisLine: {
        // 仪表盘轴线相关配置，即里面的灰色环形
        lineStyle: {
          color: [
            [0.2, '#dff1e1'],
            [0.8, '#dff1e1'],
            [1, '#dff1e1'],
          ],
          width: 55,
        },
      },
      axisTick: {
        show: false,
      },
      splitLine: {
        show: false,
      },
      axisLabel: {
        show: false,
      },
      pointer: {
        show: false,
      },
      anchor: {
        show: false,
      },
      detail: {
        valueAnimation: true,
        offsetCenter: [0, 0],
        textStyle: {
          fontSize: 24,
          color: '#26c939',
        },
      },
      data: [
        {
          value: 63.5,
          name: '',
        },
      ],
    },

    {
      type: 'gauge',
      name: '外层辅助',
      radius: '51%',
      startAngle: '225',
      endAngle: '-45',
      splitNumber: '100',
      pointer: {
        show: false,
      },
      detail: {
        show: false,
      },
      data: [
        {
          value: 1,
        },
      ],
      // data: [{value: 1, name: 90}],
      title: {
        show: true,
        offsetCenter: [0, 30],
        textStyle: {
          color: '#fff',
          fontStyle: 'normal',
          fontWeight: 'normal',
          fontFamily: '微软雅黑',
          fontSize: 20,
        },
      },
      axisLine: {
        show: true,
        lineStyle: {
          color: [[1, '#77f787']],
          width: 2,
          opacity: 1,
        },
      },
      axisTick: {
        show: false,
      },
      splitLine: {
        show: true,
        length: 20,
        lineStyle: {
          color: '#051932',
          width: 0,
          type: 'solid',
        },
      },
      axisLabel: {
        show: false,
      },
    },
    {
      name: '最内层线',
      type: 'gauge',
      radius: '36%',
      // center: ['50%', '30%'],
      axisLine: {
        show: false,
        lineStyle: {
          opacity: 0,
        },
      },
      splitLine: {
        show: true,
        lineStyle: {
          opacity: 0,
        },
      },
      axisLabel: {
        show: false,
      },
      axisTick: {
        length: -3,
        lineStyle: {
          color: '#79ff89',
          width: 3,
          type: 'solid',
        },
      },
      detail: {
        show: false,
      },
      pointer: {
        show: false,
      },
    },
  ],
}
// 维度评分雷达图
const dimensionRadarOption = {
  legend: {
    show: false, // 不显示图例
    data: [''],
  },
  radar: {
    name: {
      textStyle: {
        color: '#6e6e6e',
        fontSize: 14,
      },
    },
    indicator: [
      { name: '一致性', max: 100 },
      { name: '规范性', max: 100 },
      { name: '唯一性', max: 100 },
      { name: '及时性', max: 100 },
      { name: '准确性', max: 100 },
    ],
    splitArea: {
      show: false,
      areaStyle: {
        color: 'transparent',
      },
    },
    axisLine: {
      lineStyle: {
        color: '#e4e4e8',
      },
    },
    splitLine: {
      show: true,
      lineStyle: {
        width: 1,
        color: '#e4e4e8',
      },
    },
  },
  tooltip: {
    trigger: 'item',
  },
  series: [
    {
      name: '评分',
      type: 'radar',
      symbolSize: 8,
      data: [
        {
          name: '',
          value: [0, 0, 0, 0, 0],
          lineStyle: {
            color: '#0082f7',
          },
          itemStyle: {
            normal: {
              borderColor: '#0082f7',
            },
          },
        },
      ],
    },
  ],
}
// 质量分析柱状图
const qualityAnalysisBarOption = {
  tooltip: {
    trigger: 'axis',
  },
  legend: {
    show: true,
  },
  xAxis: {
    type: 'category',
    data: ['ASP1', 'ASP2', 'ASP3', 'ASP4', 'ASP5', 'ASP6', 'ASP7'],
    axisTick: {
      show: false,
    },
    axisLine: {
      lineStyle: {
        color: '#e4e4e8',
      },
    },
    axisLabel: {
      rotate: -45,
      color: '#6e6e6e',
    },
  },
  yAxis: {
    type: 'value',
    axisLabel: {
      color: '#6e6e6e',
    },
    axisTick: {
      show: false,
    },
    axisLine: {
      show: false,
    },
    splitLine: {
      show: true,
      lineStyle: {
        color: '#e4e4e8',
      },
    },
  },
  series: [
    {
      type: 'bar',
      data: [45, 42, 49, 30, 26, 25, 28],
      barWidth: 12,
      itemStyle: {
        color: '#35c158',
      },
    },
  ],
}
export default {
  qualityScoreLineOption,
  qualityScoreDashboardOption,
  dimensionRadarOption,
  qualityAnalysisBarOption,
}
